import { render } from "./KeyValueCollector.vue?vue&type=template&id=5ff6b692&scoped=true"
import script from "./KeyValueCollector.vue?vue&type=script&lang=js"
export * from "./KeyValueCollector.vue?vue&type=script&lang=js"

import "./KeyValueCollector.vue?vue&type=style&index=0&id=5ff6b692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff6b692"]])

export default __exports__